import { Container } from "semantic-ui-react"

export const Footer = () => {
    return (
        <Container fluid textAlign="center" style={{padding: '2%', background: 'black', color: 'white'}}>
            <h3>Copyright &copy; Faisal Bin Alamgir</h3>
        </Container>
    )
}
